import {connect} from 'react-redux';
import ModalTabuYashirAreYouSure from './ModalTabuYashirAreYouSure';
import {showGlobalErrorMessage} from '../../../../common/actions/globalErrorMessage/showGlobalErrorMessage';

export default connect(
  null,
  {showGlobalErrorMessage}
)(ModalTabuYashirAreYouSure);
